import { useMutation } from '@apollo/client';
import { VIEW_SPOT_LAST_ACTIVE } from '../../graphql/user-mutations';

export default function useMutateViewSpotLastActive() {
    const [viewSpotLastActive] = useMutation(VIEW_SPOT_LAST_ACTIVE);
    return { viewSpotLastActive };
}
